<template>
    <div class="step-basic-info">
        <v-row>
            <v-col cols="12">
                <v-menu 
                    ref="menu" 
                    v-model="menu" 
                    :close-on-content-click="false" 
                    transition="scale-transition" 
                    offset-y 
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                            outlined 
                            placeholder="Date Of Birth" 
                            :value="dateOfBirth" 
                            @input="$emit('update:dateOfBirth', $event)"
                            label="Date Of Birth" 
                            prepend-inner-icon="mdi-calendar" 
                            readonly 
                            v-bind="attrs" 
                            v-on="on" 
                            hide-details
                        />
                    </template>
                    <v-date-picker 
                        ref="picker" 
                        :value="dateOfBirth"
                        @input="onDateChange"
                        :max="maxDateOfBirth" 
                        min="1945-01-01" 
                        color="primary"
                    />
                </v-menu>
            </v-col>
        </v-row>
        <div class="timezone-info mt-4">
            <div class="timezone-label">Timezone</div>
            <div class="timezone-value">Select Times in Your Timezone <span v-if="userTimezone">({{ userTimezone }})</span></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WizardStepBasicInfo',
    props: {
        dateOfBirth: {
            type: String,
            default: ''
        },
        maxDateOfBirth: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            menu: false
        };
    },
    computed: {
        userTimezone() {
            const user = this.$store.state.userModule.user;
            return user && user.timezone ? user.timezone : null;
        }
    },
    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
        }
    },
    methods: {
        onDateChange(date) {
            this.$emit('update:dateOfBirth', date);
            this.$refs.menu.save(date);
        }
    }
};
</script>

<style lang="scss" scoped>
.timezone-info {
    padding: 15px;
    background: #FAFAFA;
    border-radius: 8px;
}

.timezone-label {
    font-family: 'Inter', sans-serif;
    font-weight: 300;
    font-size: 16px;
    line-height: 1.21em;
    letter-spacing: 0.04em;
    color: #1E1E1E;
    margin-bottom: 4px;
}

.timezone-value {
    font-family: 'Inter', sans-serif;
    font-weight: 300;
    font-size: 14px;
    line-height: 1.21em;
    color: rgba(30, 30, 30, 0.48);
}
</style>

